import { ActionTree } from "vuex";
import { UserActionsTypes, UserMutationsTypes } from "./types";
import { User, UserActions, UserState } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<UserState, UserState> & UserActions = {
  [UserActionsTypes.GET_LOGGED_USER]: async ({ commit }): Promise<void> => {
    return Client.get<void, Response_>(`user/me`).then((response) =>
      commit(UserMutationsTypes.SET_LOGGED_USER, response.body as User)
    );
  },
  [UserActionsTypes.LIST_USER]: async ({ commit }): Promise<number> => {
    return Client.get<number, Response_>(`user/list`)
      .then((response: Response_) => {
        commit(UserMutationsTypes.SET_LIST_USER, response.body as Array<User>);
        return response.status;
      })
      .catch((err) => err);
  },
  [UserActionsTypes.DELETE_USER]: async ({ commit }, user_id: string): Promise<Response_> => {
    return Client.delete<Response_, Response_>(`user/${user_id}`)
      .then((response) => {
        commit(UserMutationsTypes.DELETE_USER, response.body as User);
        return response;
      })
      .catch((err) => err);
  },
  [UserActionsTypes.DELETE_MULTIPLE_USER]: async ({ commit }, user_ids: Array<string>): Promise<Response_> => {
    return Client.delete<Response_, Response_>(`user/multiple`, { data: { ids: user_ids } })
      .then((response) => {
        commit(UserMutationsTypes.DELETE_MULTIPLE_USER, response.body as User[]);
        return response;
      })
      .catch((err) => err);
  },
  [UserActionsTypes.SEND_USER_MAIL]: async ({ commit }, user_id: string): Promise<number> => {
    return Client.post(`user/send_mail`, { id: user_id })
      .then((response) => response.status)
      .catch((err) => {
        if (err.response.status === undefined) return 500;
        return err.response.status;
      });
  },
  [UserActionsTypes.UPDATE_USER]: async ({ commit }, { user_data: user_data, _id: _id }): Promise<Response_> => {
    delete user_data._id;
    return Client.put<Response_, Response_>(`user/${_id}`, user_data)
      .then((response) => {
        commit(UserMutationsTypes.UPDATE_USER, response.body as User);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [UserActionsTypes.CREATE_USER]: async ({ commit }, user_data: any): Promise<Response_> => {
    delete user_data._id;
    return Client.post<Response_, Response_>(`user/`, user_data)
      .then((response: Response_) => {
        commit(UserMutationsTypes.CREATE_USER, response.body as User);
        return response;
      })
      .catch((err: Response_) => err);
  }
};
